import { config } from 'config';

export interface ChatConfigResponse {
  integration_key: string;
  is_messaging_enabled: boolean;
}
export class SupportClient {
  /**
   * Fetches a new chat JWT token from the server.
   */
  async getUserToken(scope: string): Promise<string | never> {
    try {
      const response = await fetch(
        `${config.url.apiBase}/auth/chat?scope=${scope}`,
        {
          method: 'GET',
          credentials: 'include',
        },
      );

      const data = await response.json();

      /**
       * TODO: Check if it is necessary to check for response.status
       */
      return data.token;
    } catch (error) {
      throw new Error(`Error retrieving token: ${error.message}`);
    }
  }

  async getChatConfig(scope: string): Promise<ChatConfigResponse> {
    try {
      const response = await fetch(
        `${config.url.apiBase}/init/chat?scope=${scope}`,
        {
          method: 'GET',
          credentials: 'include',
        },
      );

      const data = await response.json();

      /**
       * TODO: Check if it is necessary to check for response.status
       */
      return data;
    } catch (error) {
      throw new Error(`Error retrieving initial chat config: ${error.message}`);
    }
  }
}
